import { Component, Inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

export type SnackbarData = {
  message: string;
  icon?: string;
  action?: string;
};

@Component({
    templateUrl: './snackbar.component.html',
    standalone: false
})
export class SnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackbarData,
    public snackbar: MatSnackBarRef<SnackbarComponent>
  ) {}
}
